















import { Component, Vue, Prop } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'
import Avatar from '@/apps/open/components/Avatar'

@Component({
  components: {
    Button,
    Avatar
  }
})
export default class TransferConfirmDialogBody extends Vue {
  @Prop()
  selectedUser!: any

  @Prop()
  onCancel!: Function

  @Prop()
  onOk!: Function

  checkedConfirm = false

  get disabledSubmit () {
    return !this.checkedConfirm
  }
}
